import { queries } from "@testing-library/react";
import ActionTypes from "../Actions/ActionTypes"

const initialState = {
    queries: [],
    queriesPagination: null,

    webQueries: [],
    webQueriesPagination: null,

    discountCodes: [],
    discountCodesPagination: null
}

const PagesReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.GET_SUPPORT_QUERIES:
            state = { ...state, queries: action.payload?.data, queriesPagination: action.payload }
            break;

        case ActionTypes.DEL_SUPPORT_QUERY:
            let ex = [...state.queries]
            const index = ex.findIndex(item => item.id === action.payload)
            ex.splice(index, 1)
            state = { ...state, queries: ex, queriesPagination: state.queriesPagination }
            break;

        case ActionTypes.GET_DISCOUNT_CODES:
            state = { ...state, discountCodes: action.payload?.data, discountCodesPagination: action.payload }
            break;


        case ActionTypes.ADD_DISCOUNT_CODE:
            let existing_dc = [...state.discountCodes]
            existing_dc.unshift(action.payload)
            state = { ...state, discountCodes: existing_dc, discountCodesPagination: state.discountCodesPagination }
            break;


        case ActionTypes.DEL_DISCOUNT_CODE:
            let ex_dc = [...state.discountCodes]
            const index_to_be_del = ex_dc.findIndex(item => item.id === action.payload)
            ex_dc.splice(index_to_be_del, 1)
            state = { ...state, discountCodes: ex_dc, discountCodesPagination: state.discountCodesPagination }
            break;

        case ActionTypes.GET_WEB_QUERIES:
            state = { ...state, webQueries: action.payload?.data, webQueriesPagination: action.payload }
            break;

        default:
            break;
    }
    return state
}
export default PagesReducer;